/**
* Scrolling Feature JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Feature component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-feature',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.scrolling-feature' ).each( function( key, component ) {
        if ( window.innerWidth > 1023 ) {
          const height = $( this ).outerHeight();
          const panelAmount = $( this ).find( '.panel' ).length + 2;
          let navHeight = $( '.navbar' ).outerHeight();

          if ( $( '.navbar .nav-marquee' ).length ) {
            navHeight -= $( '.navbar .nav-marquee' ).outerHeight();
          }

          if ( $( '#wpadminbar' ).length ) {
            navHeight += $( '#wpadminbar' ).outerHeight();
          }

          $( component ).height( height * panelAmount - 2 );

          // pin the whole inside of the component
          const pinner = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              pin: $( component ).find( '.inner' )[0],
              start: 'top ' + navHeight,
              end: '+=' + ( height * ( panelAmount - 1 ) ), // so it can scroll away when finished
              scrub: 0,
              pinSpacing: false,
            // markers: true,
            },
          } );

          // pin the group of bags
          const bagsGroupPinner = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              pin: $( component ).find( '.bags-group' )[0],
              start: 'top ' + navHeight,
              end: '+=' + ( height * 3 ),
              scrub: 0,
              // markers: true,
              pinSpacing: false,
            },
          } );

          // move them beans
          const beanMover = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              start: 'top top',
              end: '+=' + ( height * 3 ),
              scrub: 0,
            // markers: true,
            },
          } );
          beanMover.to( $( component ).find( '.bean-group' )[0], {y: '-10%', ease: 'linear'}, 0 );

          // tuck the left back behind the center bag
          const leftBagMover = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              start: ( height * 0.65 ) + 'px' + ' top',
              end: '+=' + ( height / 2 ),
              scrub: 0,
            // markers: true,
            },
          } );
          leftBagMover.to( $( component ).find( '.bag--2' )[0], {x: '100%', rotate: '0deg', ease: 'linear'}, 0 );

          // tuck the right back behind the center bag
          const rightBagMover = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              start: ( height * 0.65 ) + 'px' + ' top',
              end: '+=' + ( height / 2 ),
              scrub: 0,
            // markers: true,
            },
          } );
          rightBagMover.to( $( component ).find( '.bag--3' )[0], {x: '-100%', rotate: '0deg', ease: 'linear'}, 0 );

          // hide the whole bags group
          const bagsHider = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              start: ( height * 1 ) + 'px' + ' top',
              end: '+=' + ( height / 2 ),
              scrub: 0,
            // markers: true,
            },
          } );
          bagsHider.to( $( component ).find( '.bags-group' )[0], {opacity: '0', ease: 'linear'}, 0 );

          // when scrolling out of each panel, do a cool swipey transition
          $( component ).find( '.panel:not(:last-child)' ).each( function( panelKey, panel ) {
            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: component,
                start: ( ( height * $( panel ).index() + 1 ) ) + 'px' + ' top',
                end: '+=' + height,
                scrub: 0,
              // markers: true,
              },
            } );
            tl.to( panel, {clipPath: 'polygon(0 0%, 100% 0%, 100% 0%, 0 0%)', ease: 'linear'}, 0 );
          } );

          // tilt the bag
          const finalBag = $( component ).find( '.panel:last-child .bag-wrapper' )[0];
          const bagTilter = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              start: ( height * ( panelAmount - 3 ) ) + 'px' + ' top',
              end: '+=' + ( height / 2 ),
              onEnter: ( self ) => {
                $( component ).find( '.panel:last-child .decorations' ).addClass( 'is-hidden' );
                $( component ).find( '.panel:last-child .content-row' ).addClass( 'is-hidden' );
              },
              onLeaveBack: ( self ) => {
                $( component ).find( '.panel:last-child .decorations' ).removeClass( 'is-hidden' );
                $( component ).find( '.panel:last-child .content-row' ).removeClass( 'is-hidden' );
              },
              scrub: 0,
            // markers: true,
            },
          } );

          if ( window.innerWidth > 1269 ) {
            bagTilter.to( finalBag, {rotate: '145deg', ease: 'linear'}, 0 );
          } else {
            bagTilter.to( finalBag, {rotate: '152deg', ease: 'linear'}, 0 );
          }

          // pour them beans
          const pouringBeans = $( component ).find( '.panel:last-child .bag-wrapper .pouring-beans' )[0];
          const beanPour = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              start: ( height * ( panelAmount - 2.5 ) ) + 'px' + ' top',
              end: '+=' + ( height ),
              scrub: 0,
            // markers: true,
            },
          } );
          beanPour.to( pouringBeans, {y: '-450%', ease: 'linear'}, 0 );

          // pour them beans
          const finalPanel = $( component ).find( '.panel:last-child' )[0];
          const fakeScrollFinalPanel = gsap.timeline( {
            scrollTrigger: {
              trigger: component,
              start: ( height * ( panelAmount - 2.5 ) ) + 'px' + ' top',
              end: '+=' + ( height ),
              scrub: 0,
            // markers: true,
            },
          } );
          fakeScrollFinalPanel.to( finalPanel, {y: '-50%', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-feature', COMPONENT );
} )( app );
